import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import Typography from '@/common/components/base/typography/Typography';
import NoResultCorrectiveImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/noResultCorrectiveImagesIcon.svg?react';
import { CorrectiveSelectedImageBar } from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/correctiveSelectedImageBar/CorrectiveSelectedImageBar';
import { CorrectiveSelectedImageBarType } from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/correctiveSelectedImageBar/CorrectiveSelectedImageBar.type';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { Box, Flex } from 'styled-system/jsx';

const CorrectiveSelectedImageBarList = ({
  points,
}: {
  points: CorrectiveSelectedImageBarType[];
}) => {
  const { preFetchedCorrectiveImages } = useCorrectiveImages();
  const renderCondition =
    points.length > 0 && preFetchedCorrectiveImages?.length > 0;

  const TitleDescriptionMapper = {
    documents: 'مدارک فردی',
    vehicle: 'تصاویر وسیله‌نقلیه',
    damaged_parts: 'نقاط اسیب دیده',
  };

  return points.length > 0 || preFetchedCorrectiveImages.length > 0 ? (
    <Flex flexDirection={'column'} gap={16} pt={8} px={16} w={'100%'}>
      <Typography color="purple-1" textStyle="b1">
        لیست تصاویر درخواستی
      </Typography>
      <Box display="flex" flexDirection={'column'} w={'100%'} gap={16}>
        {renderCondition ? (
          <Box>
            <CustomLabel title={'درخواست‌های جدید'} color="green" />
          </Box>
        ) : null}
        <Box display="flex" flexDirection={'column'} w={'100%'} gap={8}>
          {points?.map((item) => (
            <CorrectiveSelectedImageBar
              id={item.id}
              title={item.title}
              removePoint={item.removePoint}
              type={item.type}
              key={`${item.id}Key`}
              editable={item.editable}
            />
          ))}
        </Box>
      </Box>
      {preFetchedCorrectiveImages.length > 0 && (
        <Box display="flex" flexDirection={'column'} gap={16}>
          {renderCondition ? (
            <Box>
              <CustomLabel title={'درخواست‌های گذشته'} color="yellow" />
            </Box>
          ) : null}
          <Box display="flex" flexDirection={'column'} gap={8}>
            {preFetchedCorrectiveImages?.map((item) => {
              const transformeedType = TitleDescriptionMapper[item.type];
              return (
                <CorrectiveSelectedImageBar
                  id={item.id}
                  title={`${transformeedType} - ${item.title}`}
                  removePoint={() => {}}
                  type={item.type}
                  key={`${item.id}Key`}
                  editable={false}
                />
              );
            })}
          </Box>
        </Box>
      )}
    </Flex>
  ) : (
    <Flex
      flexDirection={'column'}
      gap={16}
      pt={8}
      h={'100%'}
      px={16}
      w={'100%'}
    >
      <Typography color="purple-1" textStyle="b1">
        لیست تصاویر درخواستی
      </Typography>
      <Box
        w="100%"
        h="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={16}
        position={'relative'}
        top={'-15  px'}
      >
        <NoResultCorrectiveImagesIcon />
        <Typography color="black-3" textStyle="b2">
          تصویر درخواستی‌ای ثبت نشده است.
        </Typography>
      </Box>
    </Flex>
  );
};

export default CorrectiveSelectedImageBarList;
